import { createTranslations } from '@/i18n/types';

export default createTranslations({
  en: {
    title: 'Cases',
    loading: 'Loading cases...',
    empty: 'No cases available',
  },
  ru: {
    title: 'Кейсы',
    loading: 'Загрузка кейсов...',
    empty: 'Нет доступных кейсов',
  },
  uz: {
    title: 'Keyslar',
    loading: 'Keyslar yuklanmoqda...',
    empty: 'Mavjud keyslar yoʻq',
  },
  fa: {
    title: 'کیس‌ها',
    loading: 'در حال بارگذاری کیس‌ها...',
    empty: 'کیسی موجود نیست',
  },
  pt: {
    title: 'Caixas',
    loading: 'Carregando caixas...',
    empty: 'Nenhuma caixa disponível',
  },
  tr: {
    title: 'Kasalar',
    loading: 'Kasalar yükleniyor...',
    empty: 'Uygun kasa yok',
  },
});
